<template>
    <div>
        <p class="m-0">
            <small>{{ text }}</small>
            <span class="float-right">{{ getPerformance }}</span>
        </p>
        <b-progress :value="progress" :max="max" height="6px" />
    </div>
</template>

<script>
export default {
    name: 'AverageItem',
    props: {
        text: {
            type: String,
            required: true,
        },
        performance: {
            type: Number,
            required: true,
            default: 0,
        },
        progress: {
            type: Number,
            required: true,
            default: 0,
        },
        max: {
            type: Number,
            required: false,
            default: 100,
        },
    },
    computed: {
        getPerformance() {
            return this.performance || this.performance === 0
                ? `${Math.round((this.performance + Number.EPSILON) * 100) /
                      100}%`
                : '-'
        },
    },
}
</script>
